module.exports = __webpack_public_path__ + "static/media/beep.14e404a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/beep.mp3
// module id = QbNi
// module chunks = 1